export default __webpack_public_path__ + "static/media/2-4-1.1f720c9f.webp";